import { isBrandAccentId, type BrandAccentId } from './brandAccentConstants';
import { isThemeMode, type ThemeModeId } from './themeConstants';

/** Unified registration MSAL redirect state (phase/flow/email only — access token is in-memory handoff). */
export const REGISTRATION_REDIRECT_STORAGE_KEY = 'registration_redirect';

/** Persisted light/dark preference (mirrored in `index.html` inline script for first paint). */
export const THEME_STORAGE_KEY = 'selected-theme';

/**
 * Brand accent — `html[data-brand]`.
 * Shared name across host and form apps; avoid product-specific key strings.
 */
export const BRAND_ACCENT_STORAGE_KEY = 'portal-brand-accent';

/**
 * Reads persisted theme from `THEME_STORAGE_KEY`.
 */
export function readThemeFromStorage(): ThemeModeId | null {
  try {
    const cur = localStorage.getItem(THEME_STORAGE_KEY);
    if (isThemeMode(cur)) return cur;
  } catch {
    /* ignore */
  }
  return null;
}

/**
 * Reads persisted brand accent from `BRAND_ACCENT_STORAGE_KEY`.
 */
export function readBrandAccentFromStorage(): BrandAccentId | null {
  try {
    const cur = localStorage.getItem(BRAND_ACCENT_STORAGE_KEY);
    if (isBrandAccentId(cur)) return cur;
  } catch {
    /* ignore */
  }
  return null;
}
